// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelHeader-module__main--ug2KH {
    padding-bottom: 12px;
    margin: 0 var(--panel-horizontal-padding);
    border-bottom: 1px solid var(--color-secondary-dark);
    display: flex;
    align-items: center;
    gap: 8px;
}

.PanelHeader-module__noUnderline--lSdON {
    border-bottom: none;
}

.PanelHeader-module__title--g1YfZ {
    flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/PanelHeader.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,yCAAyC;IACzC,oDAAoD;IACpD,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX","sourcesContent":[".main {\n    padding-bottom: 12px;\n    margin: 0 var(--panel-horizontal-padding);\n    border-bottom: 1px solid var(--color-secondary-dark);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.noUnderline {\n    border-bottom: none;\n}\n\n.title {\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PanelHeader-module__main--ug2KH`,
	"noUnderline": `PanelHeader-module__noUnderline--lSdON`,
	"title": `PanelHeader-module__title--g1YfZ`
};
export default ___CSS_LOADER_EXPORT___;
